import styled from "styled-components";

const c = (theme, key, fallback) => theme?.colors?.[key] ?? fallback;

export const Section = styled.section`
  background: ${({ theme }) => theme?.colors?.surface ?? "#fff"};
  border: 1px solid ${({ theme }) => theme?.colors?.border ?? "rgba(0,0,0,0.08)"};
  border-radius: 12px;
  padding: 12px;
  box-shadow: ${({ theme }) => theme?.shadows?.sm ?? "0 1px 2px rgba(0,0,0,0.04)"};
  margin-bottom: 12px;

  @media (min-width: 768px) {
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SectionBody = styled.div`
  min-width: 0;
`;

export const SectionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: ${({ theme }) => c(theme, "textMuted", "#666")};
  font-size: 0.9rem;
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  margin: 0 0 10px;
  color: ${({ theme }) => theme?.colors?.textSecondary ?? "#222"};
`;
